<section>

  <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8 p-5">
        <div class="card card-danger">
          <div class="card-header">
            <h3 class="card-title">{{getCode()}}</h3>
          </div>
          <div class="card-body">
            <h4>{{getText()}}</h4>
          </div>
        </div>
      </div>
      <div class="col-md-2"></div>

  </div>
</section>

